import React from 'react';
import { Phone, MapPin, Clock, ExternalLink } from 'lucide-react';
import { useVitrine } from '../hooks/useVitrine';

function formatHoursEN(vitrine) {
  const parts = [];
  if (vitrine.hours_label && vitrine.hours_text) {
    parts.push(`${vitrine.hours_label}: ${vitrine.hours_text}`);
  }
  if (vitrine.hours_closed) {
    parts.push(vitrine.hours_closed);
  }
  return parts.join(' — ') || 'Monday to Saturday: 12:00 PM - 2:30 PM & 7:00 PM - 10:30 PM';
}

const ContactPageEN = () => {
  const vitrine = useVitrine();

  return (
    <div className="bg-[#fafaf9]">
      <section className="relative w-full h-[50vh] flex items-center justify-center overflow-hidden">
        <img src={vitrine.hero_image} alt="Contact" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/55" />
        <div className="relative z-10 text-center mt-12">
          <span className="text-stone-300 text-[10px] tracking-[0.4em] uppercase block mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>La Taverne</span>
          <h1 className="text-white text-5xl md:text-7xl font-light tracking-tighter" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Contact
          </h1>
        </div>
      </section>

      <section className="max-w-5xl mx-auto py-20 px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <span className="text-[10px] tracking-[0.3em] uppercase text-stone-400 block mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>Find us</span>
            <h2 className="text-3xl font-light tracking-tight text-stone-900 mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Come visit us
            </h2>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-stone-100 flex items-center justify-center shrink-0"><MapPin size={18} className="text-red-900" /></div>
                <div>
                  <h3 className="text-xs uppercase tracking-[0.15em] text-stone-500 mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>Address</h3>
                  <p className="text-stone-800 text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>{vitrine.address}</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-stone-100 flex items-center justify-center shrink-0"><Phone size={18} className="text-red-900" /></div>
                <div>
                  <h3 className="text-xs uppercase tracking-[0.15em] text-stone-500 mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>Phone</h3>
                  <a href={`tel:${vitrine.phone.replace(/\s/g, '')}`} className="text-stone-800 text-sm hover:text-red-900 transition-colors" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    {vitrine.phone}
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-stone-100 flex items-center justify-center shrink-0"><Clock size={18} className="text-red-900" /></div>
                <div>
                  <h3 className="text-xs uppercase tracking-[0.15em] text-stone-500 mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>Opening Hours</h3>
                  <p className="text-stone-800 text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>{formatHoursEN(vitrine)}</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-stone-100 flex items-center justify-center shrink-0"><ExternalLink size={18} className="text-red-900" /></div>
                <div>
                  <h3 className="text-xs uppercase tracking-[0.15em] text-stone-500 mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>TripAdvisor</h3>
                  <a href="https://www.tripadvisor.fr/Restaurant_Review-g1187833-d15206020-Reviews-La_Taverne-Cayenne_Arrondissement_of_Cayenne_French_Guiana.html"
                    target="_blank" rel="noopener noreferrer"
                    className="text-red-900 text-sm hover:underline" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    See our reviews
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-stone-100 min-h-[400px] flex items-center justify-center">
            <iframe
              title="La Taverne Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.5!2d-52.3315!3d4.9372!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNMKwNTYnMTQuMCJOIDUywrAxOSc1My40Ilc!5e0!3m2!1sfr!2sgf!4v1!5m2!1sfr!2sgf"
              className="w-full h-full min-h-[400px] border-0"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPageEN;
